import { useTranslation } from 'react-i18next';
import { Form, Icon, Popover } from '@anytag/shared-atoms';
import { THEME } from '@anytag/shared-constants';
import { FormAction } from '@anytag/shared-types';
import { cn } from '@anytag/shared-utils';
import { ActionButtons } from '../action-buttons';
import { SimilarInfluencersPopperFilterSchema } from './schema';
import { Template } from './template';
import { SimilarInfluencerPopperFilterFormValues } from './types';

export type SimilarInfluencerPopperFilterProps = FormAction<SimilarInfluencerPopperFilterFormValues>;

export const SimilarInfluencerPopperFilter = ({ onSubmit, defaultValues }: SimilarInfluencerPopperFilterProps) => {
  const { t } = useTranslation();

  return (
    <Popover
      target={({ togglePopover, isOpen }) => (
        <div
          className={cn(
            'flex cursor-pointer items-center rounded-sm border-base-border bg-white px-2 py-1.5 text-size-input font-normal',
            'hover:border-base-border-hover'
          )}
          onClick={togglePopover}
        >
          <span>{t('Filter')}</span>
          <Icon
            size={11}
            icon="caret-down"
            variant="black"
            className="ml-2.5"
            // TODO: migrate to TW
            css={THEME.animation.flipX(isOpen)}
          />
        </div>
      )}
      side="bottom"
      align="end"
    >
      {({ closePopover }) => (
        <div>
          <Form.Provider<SimilarInfluencerPopperFilterFormValues>
            onSubmit={(values, methods) => {
              onSubmit(values, methods);
              closePopover();
            }}
            defaultValues={defaultValues}
            zodSchema={SimilarInfluencersPopperFilterSchema}
          >
            {({ reset }) => (
              <>
                <Template />
                <ActionButtons
                  hasTopBorder
                  secondaryButtonProps={{
                    onClick: () => {
                      closePopover();
                      reset();
                    }
                  }}
                  primaryButtonProps={{
                    type: 'submit'
                  }}
                />
              </>
            )}
          </Form.Provider>
        </div>
      )}
    </Popover>
  );
};

export * from './types';
